import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { WorkspaceAddComponent } from 'components/WorkspaceAddComponent';
import { useAuthContext } from 'hooks/useAuthContext';
import { useTranslation } from 'react-i18next';
import { WorkspaceEditComponent } from 'components/WorkspaceEditComponent';
import { WorkspaceDeleteComponent } from 'components/WorkspaceDeleteComponent';
import { RoutePaths } from 'constants/RoutePaths';
import { useNavigate } from 'react-router-dom';

export const WorkspaceContextMenu = () => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [addOpen, setAddOpen] = useState(false);
    const [editOpen, setEditOpen] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const { userState, userDispatch, refreshMyProfile } = useAuthContext();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleAddClick = () => {
        setAddOpen(true);
        handleClose();
    };

    const handleEdit = () => {
        navigate(RoutePaths.WORKSPACE_SETTINGS);
        handleClose();
    };

    const handleDelete = () => {
        setDeleteOpen(true);
        handleClose();
    };

    return (
        <>
            <IconButton onClick={handleClick}>
                <MoreVertIcon />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem onClick={handleAddClick}>
                    <ListItemIcon>
                        <AddIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>{t('admin.add')}</ListItemText>
                </MenuItem>
                <MenuItem onClick={handleEdit}>
                    <ListItemIcon>
                        <EditIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>{t('admin.edit')}</ListItemText>
                </MenuItem>
                <MenuItem onClick={handleDelete}>
                    <ListItemIcon>
                        <DeleteIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>{t('admin.delete')}</ListItemText>
                </MenuItem>
            </Menu>
            <WorkspaceAddComponent open={addOpen} onActionSuccess={refreshMyProfile} onClose={() => setAddOpen(false)}/>
            <WorkspaceEditComponent currentName={userState.user.selectedWorkspace.workspaceName} open={editOpen} onActionSuccess={refreshMyProfile} onClose={() => setEditOpen(false)}/>
            <WorkspaceDeleteComponent open={deleteOpen} onActionSuccess={refreshMyProfile} onClose={() => setDeleteOpen(false)}/>
        </>
    );
};